































































import { Component, Vue } from 'vue-property-decorator'
import Introduction from '../components/Introduction.vue'
import Balance from '../components/Balance.vue'
import { achievement, countRelation } from '@/api/user'
import { countProduct } from '@/api/product'
import { custProductTypies } from '@/api/com'

import { BaseStore, LettersType } from '@/store/modules/Base'
// import { UserStore } from '@/store/modules/User'
import { sendUrl } from '@/api/login'

// import axios from 'axios'
// import ajaxJSONP from '@/utils/jsonp'

interface orderDataType {
  orderCount: number;
  orderMoney: number;
}

interface ProductDataType {
  allNum: number;
  pushNum: number;
  supplyNum: number;
}

interface merchantDataType {
  totalNum: number;
  supplyNum: number;
  distNum: number;
}

@Component({
  name: 'businessInfo',
  components: {
    Introduction,
    Balance
  }
})
export default class businessInfo extends Vue {
  // 销售成就
  aLoading = true
  orderData: orderDataType = {
    orderCount: 0,
    orderMoney: 0
  }

  // 我的产品
  pLoading = true
  productData: ProductDataType = {
    allNum: 0,
    pushNum: 0,
    supplyNum: 0
  }

  // 关联商家
  merchantData: merchantDataType = {
    totalNum: 0,
    supplyNum: 0,
    distNum: 0
  }
  // relation: any = {}

  // 产品分类
  classifyList = []

  get letters (): LettersType {
    return BaseStore.letters
  }

  // 销售成就 数量 订单总额等
  getAchievement (): void {
    achievement()
      .then((res: orderDataType) => {
        this.aLoading = false
        if (res) {
          this.orderData = res
        }
      })
  }

  // 我的产品 数据统计
  getCountProduct () {
    countProduct()
      .then(res => {
        this.pLoading = false
        if (res.success) {
          this.productData = res.data
        }
      })
  }

  // 关联商家 数据统计
  getCountRelation () {
    countRelation()
      .then(res => {
        if (res.success) {
          this.merchantData = res.data
        }
      })
  }

  // 销售成就
  clickOrder () {
    const loading = this.$loading({
      lock: true,
      text: '跳转中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    sendUrl()
      .then(res => {
        loading.close()
        if (res.success) {
          const { uuId, webSite } = res.data
          // window.open(`https://yanshi.zowoyoo.com/cm/gtpw_set.jsp?uuId=${uuId}&pathCode=1`)
          // this.$md5() 和 this.$secretKey()  在全局 plugins 中
          const sign = new this.$md5().update(uuId + this.$secretKey()).digest('hex')
          window.open(`${webSite}/cm/gtpw_set.jsp?uuId=${uuId}&sign=${sign}&pathCode=1`)
        }
      }).catch(() => {
        loading.close()
      })
  }

  // 获取产品类型-分类
  getCustProductTypies (): void {
    custProductTypies().then((res: any) => {
      if (res) {
        this.classifyList = res.map(item => item.id)
      }
    })
  }

  mounted (): void {
    this.getCustProductTypies()
    this.getAchievement()
    this.getCountProduct()
    this.getCountRelation()
  }
}
